import React from 'react'
import ProposalPDFView from '../components/proposal/view_pdf'

const ProposalViewPDFPage = (props) => {
    return <ProposalPDFView {...props} />
}

export default ProposalViewPDFPage
